export const config = {
  title: "Salazares Construction",
  meta: {
    description:
      "Salazares Construction is a licensed and insured general contractor offering roofing, gutters, and masonry services throughout Cass County, Indiana.",
    keywords: [
      "Cass County contractor",
      "Salazares Construction",
      "roofing Indiana",
      "gutter services Logansport",
      "masonry Cass County"
    ],
    author: "Salazares Construction",
    canonicalUrl: "https://salazaresconstruction.com/",
  },
  sections: {
    header: {
      businessName: "Salazares Construction",
    },
    sectionB: {
      heroTitle: "Salazares Construction",
      heroSubtitle: "Reliable Roofing, Gutters & Masonry in Cass County, IN",
      learnAboutText: "Request a Quote",
      phoneNumber: "5746019288",
      phoneLabel: "(574) 601‑9288",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/2198945002/photo/unfinished-brick-houses-with-scaffolding.jpg?s=612x612&w=0&k=20&c=JPnWD3eGzWwutkGzMgtg42rrkUrBOLQi3IJw6kYokHM=",
      cardData: [
        {
          title: "Roofing",
          description: "Shingle and metal roof repairs, full replacements and inspections.",
        },
        {
          title: "Gutter Systems",
          description: "Seamless gutters, gutter guards, downspouts and seasonal maintenance.",
        },
        {
          title: "Masonry Services",
          description: "Brick & stone facades, retaining walls, tuckpointing and repointing.",
        },
      ],
      description:
        "Serving both residential and commercial customers across Cass County, Indiana—including Logansport and Galveston—Salazares Construction delivers professional workmanship in roofing, gutters, and masonry with 24/7 emergency availability.",
    },
    sectionC: {
      servicesTitle: "Our Services",
      servicesDescription:
        "Expert roofing, gutter installation and masonry work tailored to meet your needs.",
      cards: [
        {
          title: "Roof Installation & Repair",
          description:
            "Licensed roofing services using top quality materials and workmanship.",
          imageSrc: "https://media.istockphoto.com/id/2157298355/photo/work-at-heights-a-roofer-with-tool-belt-and-save-harness-climbing-to-the-top-of-the-roof.jpg?s=612x612&w=0&k=20&c=i5v3GyGKh7H3RZhX8NxBAsYQYjF2PSlj6CVY5TQGxb8=",
          imageAlt: "Roofing",
        },
        {
          title: "Gutters & Downspouts",
          description:
            "Installation, repair and seasonal maintenance of seamless gutters.",
          imageSrc: "https://media.istockphoto.com/id/157434729/photo/three-men-installing-seamless-aluminum-gutters-on-home.jpg?s=612x612&w=0&k=20&c=tF_p23Mf9lVrfIzvVqW4frty4NsHaw1ooT5XWVIbMxM=",
          imageAlt: "Gutter Services",
        },
        {
          title: "Masonry & Stone Work",
          description:
            "Custom brickwork, retaining walls and tuck‑pointing for structural beauty.",
          imageSrc: "https://media.istockphoto.com/id/165866996/photo/bricky.jpg?s=612x612&w=0&k=20&c=dlq-Stz1Y9Z7tgihuqtvKLZrY0NEBjWqrIC0ZZT0Xa8=",
          imageAlt: "Masonry Services",
        },
      ],
      otherServicesTitle: "Why Choose Us",
      otherServicesList: [
        "Licensed & Insured",
        "24/7 Emergency Response",
        "Free Written Estimates",
        "Local Cass County Team",
        "Transparent Pricing & Communication",
      ],
    },
    sectionD: {
      aboutTitle: "About Salazares Construction",
      aboutImage: {
        src:
          "https://lirp.cdn-website.com/a42d4b3c/dms3rep/multi/opt/Copy-of-Title-ab4446c4-139w.png",
        alt: "Salazares Construction Team",
      },
      aboutText: [
        "Salazares Construction is a local Cass County general contractor founded on the principles of trust, professionalism, and exceptional craftsmanship.",
        "We specialize in roofing, gutters, and masonry projects and offer emergency availability and free estimates to support our community.",
      ],
    },
    sectionE: {
      profileImage: "https://lirp.cdn-website.com/a42d4b3c/dms3rep/multi/opt/Copy-of-Title-ab4446c4-139w.png",
      profileAlt: "Salazares Construction Logo",
      businessName: "Salazares Construction",
      contact: {
        phone: "5746019288",
        phoneLabel: "(574) 601‑9288",
        email: "Salazaresconstruction@gmail.com",
        website: "https://salazaresconstruction.com/",
        address: "Cass County, Indiana",
      },
      socialMedia: {},
    },
    sectionF: {
      address: "Cass County, Indiana",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d48338.12345!2d-86.350!3d40.754!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x...!2sCass+County,+IN!5e0!3m2!1sen!2sus!4v1710000000000!5m2!1sen!2sus",
    },
  },
};

export default config;
